import Api from '../global/api';  
const profileReducer = (state = {
    status: 'LOADING',
    msg: '',
    data: {}
}, action) => {
    const current_data = JSON.parse(JSON.stringify(state));
    const status = typeof action.status !== 'undefined' ? action.status.toUpperCase(): null;

    switch(action.type){
        case "PROFILE_LOAD":
            state = {
                ...state,
                status: status,
                msg: status === 'ERROR'?action.payload:'',
                data: status === 'OK'?action.payload:current_data
            }
            break;
        case "PROFILE_UPDATE":                
            state = {
                ...state,
                status: status,
                msg: status === 'ERROR'?action.payload:'',
                data: status === 'OK'?action.payload:current_data
            }
            Api.setLocal('profile', state.data);
            break;
        default:
    }
    return state;
}

export default profileReducer;